export default {
  menuTitle: '佣金订单列表',
  pageTitle: '佣金订单列表',
  paidDate: '支付时间',
  startDate: '开始日期',
  endDate: '结束日期',
  orderStatus: '订单状态',
  commissionStatus: '佣金状态',
  attributionType: '归因类型',
  all: '全部',
  soSerial: '订单号',
  soSerialPlaceholder: '请输入订单号',
  soSerialSku: '订单商品行号',
  soSerialSkuPlaceholder: '请输入订单商品行号',
  search: '查询',
  export: '导出',
  exportFailed: '导出失败，请稍后重试',
  exportLimitExceeded: '导出最多支持 5,000 行，请缩小筛选范围后重新导出',
  reset: '重置',
  product: '商品',
  productIds: 'Listing ID / SKU ID',
  quantity: '数量',
  productRealAmount: '商品实付金额',
  commissionRate: '佣金率',
  effectiveCommissionAmount: '有效佣金',
  attributionEffectiveAt: '归因生效时间',
  unavailableProduct: '商品信息暂不可用',
  noCommission: '不产生佣金',
  noCommissionReason: '不产佣原因：{reason}',
  statusPending: '待结算',
  statusProtected: '保护期',
  statusSettled: '待打款',
  statusPaid: '已打款',
  statusRefunded: '已退款',
  statusBanned: '已作废',
  lifecyclePaid: '已支付',
  lifecycleSigned: '已签收',
  lifecycleCancelled: '已取消',
  attributionCps: '正常',
  attributionSelfPurchase: '自购',
  attributionProductExited: '商品退出',
  attributionCreatorBanned: '永久封禁',
  attributionNegligible: '佣金过低',
  loadFailed: 'CPS 订单加载失败',
  unknownError: '请求失败，请稍后重试',
  businessTimezone: '时间按内罗毕时区显示'
}
